import { abUseExperimentsSelector, isAbUseExperimentsActive } from 'shared/selectors';
import { AUD_AUTH_TRAP } from 'shared/services/abUseExperiments/experiments';
import { IState } from 'shared/store';

export const selectIsAuthorizationTrapExperimentEnabled = (state: IState): boolean => {
  const experiments = abUseExperimentsSelector(state);

  return isAbUseExperimentsActive(experiments, AUD_AUTH_TRAP, 'B');
};
